
import banImg1 from "../../assets/images/services/red-teaming/redt-banner.webp";
import banImg2 from "../../assets/images/services/red-teaming/redt-intro.webp";
import features01 from "../../assets/images/services/red-teaming/red-teaming-featu-01.webp";
import features02 from "../../assets/images/services/red-teaming/red-teaming-featu-02.webp";
import features03 from "../../assets/images/services/red-teaming/red-teaming-featu-03.webp";
import features04 from "../../assets/images/services/red-teaming/red-teaming-featu-04.webp";
import features05 from "../../assets/images/services/red-teaming/red-teaming-featu-05.webp";
import features06 from "../../assets/images/services/red-teaming/red-teaming-featu-06.webp";
import features07 from "../../assets/images/services/red-teaming/red-teaming-featu-07.webp";
import features08 from "../../assets/images/services/red-teaming/red-teaming-featu-08.webp";

const RedTeamingData = {
    "BannerData":[
        {
            "title": "Strategic <span>Red<br/> Teaming</span> Services",
            "bannerBtnText": 'Let’s Connect',
            "bannerBigimg" : `${banImg1}`,
            "bannerAlt": 'Android App Development',
        },
    ],

    "Introduction":[
        {
            "introContent" :`Our Red Teaming service goes beyond traditional penetration testing to simulate real-world cyber attacks and assess your organization's security posture comprehensively. By adopting an adversarial mindset, our expert team identifies vulnerabilities, tests response capabilities, and strengthens defenses against evolving cyber threats. We provide actionable insights to enhance your cybersecurity resilience.`,
            "introImg": `${banImg2}`,
            "brochurelink": "/",
        }
    ],

    "ServiceBenifits" : [
        {   
            "benifitCont" : "Identify and mitigate security weaknesses before attackers do",
        },
        {
            "benifitCont" : "Test and validate security controls and incident response plans",
        },
        {
            "benifitCont" : "Enhance security awareness and readiness among employees",
        },
        {
            "benifitCont" : "Stay ahead of emerging cyber threats and attack vectors",
        },
        {
            "benifitCont" : "Improve overall cybersecurity posture and resilience",
        },
        {
            "benifitCont" : "Receive actionable insights and recommendations for risk mitigation",
        },
    ],

    "FeaturesServices":[
        {
          
            "featureDescriptiom":"Advanced threat simulations and attack scenarios",
            "FeatImg" : `${features01}`,
            "FeatImgAltTag" : "Native Android Apps",
            
        },
        {
            
            "featureDescriptiom":"Red teaming exercises tailored to your business environment",
            "FeatImg" : `${features02}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Social engineering and phishing assessments",
            "FeatImg" : `${features03}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Vulnerability discovery and exploitation techniques",
            "FeatImg" : `${features04}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Active reconnaissance and threat intelligence gathering",
            "FeatImg" : `${features05}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Evaluation of incident response and mitigation strategies",
            "FeatImg" : `${features06}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Reporting and recommendations for security improvements",
            "FeatImg" : `${features07}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Collaboration with internal security teams",
            "FeatImg" : `${features08}`,
            "FeatImgAltTag" : "Web Apps",
        },
       
    ],


    "FooterCtaSection":[
        {
            "CtaDescriptiom":"Fortify your defenses with strategic Red Teaming. Contact us today to schedule an assessment and discover how our services can protect your organization from cyber threats.",
            "CtaBtnText": 'Let’s Connect',
            "CtaBtnLink": '/get-a-quote',
        },
    ],


    
} 

export default RedTeamingData